module.exports = __webpack_public_path__ + "img/second.d9002da4.png";